/**
 * Component Sort by
 * 
 * @module component-sort-by
 * @version 1.0.0
 * @extends HTMLElement
 */

 customElements.component = 'component-sort-by';

 if (!customElements.get(customElements.component)) {

    class componentSortBy extends HTMLElement {
 
    /**
     * Sort By web component.
     * 
     * @constructor
     */
    constructor() {

    super();
    
    this.initEvents();
    }

	/**
	 * Init module
	 */
     initEvents()  {

        this.initSortBy();
	}


    /**
	 * Init Sort by
	 */
    initSortBy() {

        let select = this.querySelectorAll("select");

        select.forEach((element) => {

            element.addEventListener('change', (event) => {
                let sort_by_value = element.value || element.defaultSort;
                let urlSearchParams = new URLSearchParams(window.location.search);

                if (urlSearchParams.has('page') == true) {
                    urlSearchParams.delete('page');
                }

                urlSearchParams.set("sort_by", sort_by_value);
                window.location.search = urlSearchParams.toString();

            });
            
        });
    }

    }

    customElements.define(customElements.component, componentSortBy);
}
